export const translation_10_3_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `변화의 문턱`,
      typography_1: `살아가다 보면 종종 변화가 필요한 순간을 마주하게 됩니다. 그리고 바로 지금, 그 순간을 마주하고 계시지요. 하지만 막상 무언가를 바꾸려 하면 알 수 없는 망설임이 발목을 잡곤 합니다. 본격적으로 변화를 향해 나아가기 전, 나는 정확히 어떤 변화를 바라고 있는지 살펴보도록 하겠습니다.`,
      typography_2: `아래 질문들을 천천히 읽으며 지금의 상황을 떠올리고, 솔직한 답변을 적어보세요. 마음 깊은 곳에 자리한 복잡한 감정들을 마주하는 첫걸음이 될 것입니다.`,
      typography_mobile_notice: `모바일 기기에서의 타이핑이 불편하다면 컴퓨터로 https://distancing.im 으로 접속해서 작성해주세요.`,
      typography_3: `요즘 가장 힘들거나 변화가 필요하다고 느끼는 부분은 무엇인가요?`,
      typography_4: `지금의 상황을 유지할 때 얻는 편안함이나 장점은 무엇인가요?`,
      typography_5: `하지만 이대로 계속 지낸다면 어떤 점이 가장 걱정되시나요?`,
      typography_6: `변화를 통해 일상에 어떤 좋은 일이 생기기를 기대하시나요?`,

      typography_7: `마법의 버튼`,
      typography_8: `마음이 몹시 괴로울 때는 종종 모든 고통을 한 번에 없애고 싶다는 충동이 듭니다. 만약 눈앞에, 누르기만 하면 부정적인 생각과 감정이 순식간에 사라지는 '마법의 버튼'이 있다고 상상해 보세요. 주저 없이 이 버튼을 누르시겠습니까?`,
      typography_9: `아마 고통에서 벗어나기 위해 버튼을 누르겠다고 생각하는 분이 많을 겁니다. 하지만 이것이 과연 현명한 선택일지 생각해볼 필요가 있습니다. 부정적인 감정이 모두 사라진다는 건 겉보기엔 무척 매력적이지만, 사실 아주 큰 대가를 치러야 하는 일이기 때문입니다.`,
      typography_10: `마법의 버튼을 눌러 모든 부정적인 감정이 당장 사라진다면, 앞으로의 삶은 어떻게 될까요?`,

      typography_11: `숨겨진 의미`,
      typography_12: `부정적인 감정과 생각에도 나름의 존재 이유와 숨겨진 장점이 있습니다. 지금 느끼는 불안이나 우울 속에는 삶을 더 나아지게 만들려는 책임감, 혹은 타인을 향한 깊은 공감 능력이 숨어있을지도 모릅니다. 마법의 버튼을 눌러 부정적인 감정을 아예 지워버리면, 이처럼 소중한 가치관마저 함께 사라지진 않을까요?`,
      typography_13: `이 감정들이 내게 주는 유익함은 무엇인지, 그 이면에 숨겨진 나의 긍정적인 자질은 무엇인지 한번 살펴보세요. 막연히 피하고만 싶었던 감정들이 사실은 나 자신을 지키기 위해 애쓰고 있었다는 걸 깨닫게 될지도 모릅니다. 자, 긍정적인 면모까지 모두 잃게 된다고 해도 여전히 그 버튼을 누르고 싶으신가요?`,
      typography_14: `마음이 복잡해지고 이러지도 저러지도 못하는 망설임이 생긴다 해도 괜찮습니다. 기분이 나아지길 바라는 마음과 소중한 자질을 잃고 싶지 않은 마음이 부딪히는 건 너무나 자연스러운 현상이니까요. 변화 앞에서 겪는 이러한 내적 갈등은 지극히 당연한 일입니다.`,

      typography_15: `마법의 다이얼`,
      typography_16: `해법은 '마법의 버튼'이 아닌 '마법의 다이얼'에 있습니다. 이 다이얼은 감정을 아예 없애버리는 것이 아니라, 볼륨을 줄이듯 감당할 수 있는 정도로 감정의 크기를 조절하는 도구입니다.`,
      typography_17: `이 다이얼로 우리는 감정과 '나' 사이의 거리를 조절할 수 있습니다. 다시 말해, 긍정적인 면은 최대한 활용하는 동시에 부정적인 면은 최소화할 수 있는 적정 거리를 잡을 수 있다는 뜻입니다.`,
      typography_18: `슬픔과 우울이 지닌 긍정적인 가치들을 고려할 때, 본연의 모습을 잃지 않으면서도 편안하게 일상을 보낼 수 있는 '최적의 거리'를 찾는 것이 중요합니다. 너무 가깝지도 멀지도 않은, 자신에게 딱 맞는 적절한 수준을 이제 익혀나가게 될 것입니다.`,
      typography_19: `감정의 다이얼이 있다면, 현재 부정적인 감정의 눈금을 10 중에서 어디쯤으로 맞추고 싶으신가요?`,

      typography_20: `선택의 순간`,
      typography_21: `원하는 만큼 감정의 크기를 조절할 수 있도록 돕는 구체적인 방법들을 이제 곧 프로그램을 통해 배워나갈 겁니다. 하지만 이 다이얼을 쥐고, 어떤 감정을 얼만큼 느끼며 살아갈지 결정할 권한은 오직 본인에게 있습니다. 이 프로그램은 스스로 원하는 방향으로 나아갈 수 있도록 곁에서 돕고 지지하는 길잡이 역할을 할 것입니다.`,
      typography_22: `이제 다이얼의 눈금을 조금씩 돌려가며 적정 수준을 맞춰보겠습니다. 부정적인 감정과 적절히 거리를 두며 스스로를 돌보는 방법을 함께 알아가 봅시다.`,
    },
  },
};
